export default {
    layout: {
        loading: 'កំពុងជួញដូរ',
        trading: 'កំពុងជួញដូរ'
    },
    footer: {
    },
    menu: {
        home: 'ទំព័រដើម',
        staking: 'ម៉ាទ្រីស',
        port: 'PORT',
        internet: 'បណ្តាញ',
        me: 'របស់ខ្ញុំ',
    },
    header: {
        selectLang: 'ជ្រើសរើសភាសា',
        close: 'បិទ',
        trading: 'ការជួញដូរ',
        dashboard: 'ផ្ទាំងគ្រប់គ្រង',
        subscribeMatrix: 'ជាវម៉ាទ្រីស',
        portTaskCenter: 'មជ្ឈមណ្ឌលភារកិច្ច PORT',
        network: 'បណ្តាញ',
        apiBinding: 'ភ្ជាប់ API',
        gridTree: 'មែកធាងក្រឡា',
        account: 'គណនី',
        documents: 'ឯកសារ និង សៀវភៅស',
        personalCenter: 'មជ្ឈមណ្ឌលផ្ទាល់ខ្លួន',
        language: 'ភាសា'
    },
    home: {
        recently1:'សហគមន៍',
        staticrewares: 'ថេរ',
        recentlyName: 'សៀវភៅគណនេយ្យ',
        recentlyInfo: 'ព័ត៌មានលម្អិតអំពីចំណូល',
        dataUpdate: 'ធ្វើបច្ចុប្បន្នភាពទិន្នន័យ',
        realtime: 'ពេលវេលាពិត·BSC',
        totalRevenue: 'ចំណូលសរុប (USDT)',
        today: 'ថ្ងៃនេះ',
        totalTradingVolume: 'ទំហំជួញដូរសរុប',
        todayEarn: 'ចំណូលថ្ងៃនេះ',
        share: 'ចែករំលែកទៅមិត្តភក្តិ',
        shareDesc: 'បង្ហាញចំណូល អញ្ជើញមិត្តភក្តិ ទទួលរង្វាន់',
        directReferrals: 'ចំនួនអ្នកណែនាំផ្ទាល់',
        teamMembers: 'ចំនួនសមាជិកក្រុម',
        thisWeek: 'សប្តាហ៍នេះ',
        copy: 'ចម្លង',
        recently: 'ចំណូលថ្មីៗ',
        netIncome: 'ចំណូលសុទ្ធ',
        dailyAverage: 'មធ្យមប្រចាំថ្ងៃ',
        quantitativeIncome: 'បរិមាណ',
        recommend: 'ណែនាំ',
        port: 'PORT',
        bonus: 'ប្រាក់រង្វាន់',
        all: 'ទាំងអស់',
        todayTitle: 'ថ្ងៃនេះ',
        loadingMore: 'ផ្ទុកបន្ថែម',
        recommendBonus: 'រង្វាន់ណែនាំ',
        portTaskPassed: 'ភារកិច្ច PORT បានឆ្លងកាត់',
        myProfit: 'ចំណេញ/ខាតរបស់ខ្ញុំ',
        earningOnBitDeep: 'ខ្ញុំរកចំណូលនៅ BitDeep',
        totalRevenueUsdt: 'ចំណូលសរុប · USDT',
        consecutiveDays: 'ចំនួនថ្ងៃជាប់គ្នា',
        scanToJoin: 'ស្កេនដើម្បីចូលរួម',
        uid: 'UID',
        referralBonus: 'រង្វាន់ណែនាំ',
        shareTo: 'ចែករំលែកទៅ',
        eachReferral: 'រង្វាន់ចែករំលែក',
        screenshotAndShare: 'ថតអេក្រង់ និង ចែករំលែក',
        saveShareEarn: 'រក្សាទុក · ផ្ញើ · ទទួលរង្វាន់',
        period: 'រយៈពេល',
        netProfit: 'ចំណេញសុទ្ធ',
        quantReward: 'ចំណូលបរិមាណ',
        dailyBonus: 'រង្វាន់ប្រចាំថ្ងៃ PORT',
        close: 'បិទ',
        permission: 'សិទ្ធិ',
        onlyEnable: 'បើកតែ',
        enterBitgetUid: 'បញ្ចូល BITGET UID',
        slogan: 'ស្លោក',
        document: 'ឯកសារ',
        days: 'ថ្ងៃ',
        taskText: 'ភារកិច្ច',
        minutes: 'នាទី',
        decentralizedPortTech: 'ស្ថាបត្យកម្មបច្ចេកវិទ្យា PoRT ការចែកចាយ, សេដ្ឋកិច្ច Token BGB និង ម៉ាទ្រីសលើកទឹកចិត្តពីរតំបន់។',
        auditReport: 'របាយការណ៍ត្រួតពិនិត្យ',
        faqSupport: 'សំណួរញឹកញាប់ & ការគាំទ្រ',
        telegram: 'Telegram',
        piece: 'ផ្នែក',
        faq: 'សំណួរញឹកញាប់',
      faq1: 'តើភ្ជាប់ Bitget API យ៉ាងដូចម្តេច?',
        faq1Desc: 'ចូលទៅ Bitget Exchange → ការកំណត់ → ការគ្រប់គ្រង API ដើម្បីទទួលបាន API Key និង Secret។ បើកសិទ្ធិតែ Spot Trading ប៉ុណ្ណោះ; ហាមឃាត់បើកសិទ្ធិដក។ បិទភ្ជាប់សោទៅ BitDeep DApp។ បន្ទាប់ពីការជួញដូរសាកល្បង 1 USDT បានបញ្ចប់ ការភ្ជាប់នឹងសកម្ម។',
        faq2: 'តើ PoRT (ភស្តុតាងជួញដូរពិត) គឺជាអ្វី?',
        faq2Desc: 'PoRT គឺជាយន្តការស្នូលនៃ"ការជួញដូរស្មើនឹងការជីក"។ ប្រព័ន្ធប្រើ Bitget API ដើម្បីដំណើរការទិញ-លក់រហ័សលើកាក់ដែលបានកំណត់ (ដូចជា BGB) ដោយស្វ័យប្រវត្តិរាល់ថ្ងៃ។ ពេលដែលបរិមាណជួញដូរលើស Stake × 50% ប្រព័ន្ធផ្ទៀងផ្ទាត់ហើយផ្តល់រង្វាន់ប្រចាំថ្ងៃ។',
        faq3: 'តើខ្ញុំត្រូវតាមដានដោយដៃរាល់ថ្ងៃទេ?',
        faq3Desc: 'មិនចាំបាច់ទេ។ បន្ទាប់ពីភ្ជាប់ API ប្រព័ន្ធបញ្ចប់ភារកិច្ចជួញដូរដោយស្វ័យប្រវត្តិក្នុងបង្អួច 24 ម៉ោង។ មិនត្រូវការសកម្មភាពដោយដៃទេ; អ្នកអាចពិនិត្យនៅម៉ឺនុយ PoRT។',
        faq4: 'តើ ALPHA និង SIGMA ខុសគ្នាយ៉ាងណា?',
        faq4Desc: 'ALPHA (ដំបូង): ដាក់ភ្នាល់ 500 USDT, ទិន្នផលប្រចាំថ្ងៃ 0.3–1.3%, កំណត់ 1 កញ្ចប់។ SIGMA (ជំនាញ): ដាក់ភ្នាល់ 1,000 USDT, ទិន្នផលប្រចាំថ្ងៃ 0.6–1.6%, អតិបរមា 5 កញ្ចប់។',
        faq5: 'តើថវិការបស់ខ្ញុំមានសុវត្ថិភាពទេ? តើវេទិកាអាចប៉ះប្រាក់ខ្ញុំបានទេ?',
        faq5Desc: 'មូលនិធិរបស់អ្នកនៅ 100% ក្នុងគណនី Bitget ផ្ទាល់របស់អ្នក។ API ផ្តល់សិទ្ធិតែការអាននិងជួញដូរ spot ប៉ុណ្ណោះ; ប្រព័ន្ធមិនអាចដកឬផ្ទេរប្រាក់ដើមណាមួយឡើយ។',
        faq6: 'តើចំណូលប្រចាំថ្ងៃត្រូវបានដោះស្រាយនៅពេលណា?',
        faq6Desc: 'បន្ទាប់ពី PoRT ផ្ទៀងផ្ទាត់ជោគជ័យ ការដោះស្រាយធ្វើនៅថ្ងៃបន្ទាប់។ ប្រព័ន្ធដោះលែងរង្វាន់ពីរប្រភេទដោយស្វ័យប្រវត្តិ: ចំណូល USDT និងពិន្ទុ 10x Deep។',
        faq7: 'តើ Scout Bonus (រង្វាន់ការណែនាំផ្ទាល់) គណនាដោយរបៀបណា?',
        faq7Desc: 'សម្រាប់គណនីសកម្មនីមួយៗដែលអ្នកណែនាំផ្ទាល់, អ្នកនឹងទទួលបានរង្វាន់ថេរប្រចាំថ្ងៃ: 1 USDT/ថ្ងៃ សម្រាប់ការណែនាំ ALPHA (500 USDT), 2 USDT/ថ្ងៃ សម្រាប់ការណែនាំ SIGMA (1,000 USDT), រហូតដល់វដ្តគណនីនោះបញ្ចប់។',
        faq8: 'តើធ្វើដូចម្តេចដើម្បីឡើងកម្រិត (D1–D7)?',
        faq8Desc: 'ឡើងកម្រិតដោយផ្អែកលើបរិមាណសរុបនៅខាងតំបន់តូច។ ឧទាហរណ៍: D1 ត្រូវការ 2,000 USDT, D3 ត្រូវការ 15,000 USDT, D7 (កម្រិតខ្ពស់បំផុត) ត្រូវការ 3,000,000 USDT។ កម្រិតកាន់តែខ្ពស់ រង្វាន់ភាពខុសគ្នាកម្រិតកាន់តែច្រើន (D7 រហូតដល់ 7 USDT/នាក់/ថ្ងៃ)។',
        faq9: 'តើវដ្តមួយមានប៉ុន្មានថ្ងៃ? បន្ទាប់ពីផុតកំណត់ធ្វើដូចម្តេច?',
        faq9Desc: 'វដ្តមួយរយៈពេល 28 ថ្ងៃ។ បន្ទាប់ពីវដ្តបញ្ចប់ អ្នកអាចជ្រើសរើសបន្តដាក់ភ្នាល់; រង្វាន់ត្រូវបង់តាមលទ្ធផលផ្ទៀងផ្ទាត់ PoRT ប្រចាំថ្ងៃជាក់ស្តែង (ទិន្នផលប្រែប្រួល)។',
        faq10: 'តើមានកម្រៃសម្រាប់ការដកប្រាក់ទេ?',
        faq10Desc:'ការដកប្រាក់គឺ 0 កម្រៃ។ វេទិកាបញ្ជូនកម្រៃដកប្រាក់ត្រឡប់ទៅអាងវិញ ដើម្បីពង្រឹងសាច់ប្រាក់ LP បង្កើតជាវដ្តវិជ្ជមាន។',
        bigArea: 'តំបន់ធំ',
        smallArea: 'តំបន់តូច',
        enterWithdrawAmount: 'បញ្ចូលចំនួនដក',
        all: 'ទាំងអស់',
        available: 'អាចប្រើបាន',
        totalAmount: 'ចំនួនសរុប',
        confirmWithdraw: 'បញ្ជាក់ការដក',
        withdrawRecord: 'ប្រវត្តិការដក',
        withdrawn: 'បានដកហើយ',
        quickStartGuide:'មគ្គុទេសក៍ចាប់ផ្តើមរហ័ស',
        whitepaperGuide:'Whitepaper & មគ្គុទេសក៍',
        whitepaper:'Whitepaper',
        downloadPdf:'ទាញយក'
    },
    staking: {
        selectPackage: 'ជាវម៉ាទ្រីស',
        alpha: 'ALPHA',
        beginner: 'អ្នកចាប់ផ្តើម',
        sigma: 'SIGMA',
        professional: 'វិជ្ជាជីវៈ',
        popular: 'ពេញនិយមបំផុត',
        dailyReturn: 'រង្វាន់ភារកិច្ច ',
        teamDepth: 'ជម្រៅក្រុម',
        limitPurchase: 'កំណត់ការទិញ',
        layer: 'ស្រទាប់',
        copy: 'ផ្នែក',
        autoRenew: 'បន្តស្វ័យប្រវត្តិពេលផុតកំណត់',
        autoReinvest: 'រឹមបន្តដោយស្វ័យប្រវត្តិ',
        subscribeAlpha: 'ជាវ Alpha',
        subscribeSigma: 'ជាវ Sigma',
        stakedAmount: 'ប្រាក់ធានា',
        stakedAmount2: 'រយៈពេល',
        stakedAmount3: 'ចំណូលសរុប',
        stakingTime: 'ពេលវេលាចូលរួម',
        maturityTime: 'ពេលវេលាផុតកំណត់',
        redeem: 'ដក',
        renew: 'បន្ត',
        autoRenewActive: 'បានបន្តស្វ័យប្រវត្តិ',
        autoRenewInactive: 'មិនបានបន្តស្វ័យប្រវត្តិ',
        smartContract: 'កិច្ចសន្យាឆ្លាតវៃ ប្រាក់ធានា  28 ថ្ងៃ បើកពេលផុតកំណត់។',
        alter2:'The pledge has expired, please renew it.',
    },
    me: {
        account: 'គណនី',
        my: 'របស់ខ្ញុំ',
        staked: 'បានចូលរួម',
        staked1:'ប្រាក់ធានា',
        points: 'ពិន្ទុ',
        consecutive: 'ថ្ងៃជាប់គ្នា',
        withdraw: 'ដក',
        language: 'ភាសា',
        simplifiedChinese: 'ភាសាចិនកាត់',
        disconnectWallet: 'ផ្តាច់កាបូប',
        level: 'កម្រិត',
        joinDate: 'កាលបរិច្ឆេទចូលរួម',
        bdId: 'BD-ID'
    },
        bindapi: {
        apiBinding: 'ភ្ជាប់ API',
        bindDesc: 'ភ្ជាប់ API Key របស់ Exchange ដើម្បីអនុញ្ញាតការជួញដូរ',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'ប្តូរ',
        futures: 'កិច្ចសន្យា',
        spot: 'Spot',
        readOnly: 'អានតែប៉ុណ្ណោះ',
        bind: 'ភ្ជាប់',
        riskNote: 'API Key ប្រើសម្រាប់សមកាលកម្មទិន្នន័យជួញដូរ តែមិនរក្សាទុកព័ត៌មានសំខាន់',
        apiConnection: 'ការភ្ជាប់ API',
        bindExchangeApi: 'ភ្ជាប់ API របស់ Exchange',
        bitDeepRead: 'BitDeep អានលំហូរបញ្ជាទិញពីគណនី CEX របស់អ្នក ដើម្បីផ្ទៀងផ្ទាត់ការជួញដូរពិតប្រាកដ (PoRT)',
        noWithdraw: 'យើងមិនដែលប៉ះពាល់ដល់ការដកប្រាក់របស់អ្នកទេ។',
        securityTip: 'ព័ត៌មានសុវត្ថិភាព · សូមអានយ៉ាងម៉ត់ចត់',
        close: 'បិទ',
        withdraw: 'ដក',
        permission: 'សិទ្ធិ',
        onlyEnable: 'បើកតែ',
        spotTrading: 'ការជួញដូរ Spot',
        read: 'អាន',
        recommendedPartner: 'ដៃគូណែនាំ',
        zeroFee: '0% កម្រៃ',
        activated: 'បានបើក',
        classicAccount: 'គណនី Classic',
        unifiedAccount: 'គណនីរួម',
        bindBitgetApi: 'ភ្ជាប់ Bitget API',
        upcoming: 'មកដល់ឆាប់ៗ',
        underAudit: 'កំពុងត្រួតពិនិត្យ',
        expected: 'រំពឹងទុក'
    },
    port: {
        portTaskCenter: 'មជ្ឈមណ្ឌលភារកិច្ច PORT',
        dailyTask: 'ភារកិច្ចប្រចាំថ្ងៃ',
        verify: 'ផ្ទៀងផ្ទាត់',
        completed: 'បានបញ្ចប់',
        incomplete: 'មិនទាន់បញ្ចប់',
        verifyStandard: 'ស្តង់ដារផ្ទៀងផ្ទាត់',
        tradingVolume: 'ទំហំជួញដូរ',
        today: 'ថ្ងៃនេះ',
        deadline: 'កាលកំណត់',
        reward: 'រង្វាន់',
        startVerify: 'ចាប់ផ្តើមផ្ទៀងផ្ទាត់',
        verifying: 'កំពុងផ្ទៀងផ្ទាត់',
        verified: 'បានផ្ទៀងផ្ទាត់',
        insufficient: 'មិនគ្រប់គ្រាន់',
        viewDetails: 'មើលព័ត៌មានលម្អិត',
        taskList: 'បញ្ជីភារកិច្ច',
        allTasks: 'ភារកិច្ចទាំងអស់',
        completedTasks: 'បានបញ្ចប់',
        pendingTasks: 'កំពុងរង់ចាំ',
        proofOfRealTrading: 'ភស្តុតាងជួញដូរពិតប្រាកដ',
        todayTask: 'ភារកិច្ចថ្ងៃនេះ',
        todayStaticIncome: 'រង្វាន់ភារកិច្ចថ្ងៃនេះ',
        points: 'ពិន្ទុ',
        todayWindowClosesAt: 'បង្អួចថ្ងៃនេះបិទនៅ',
        checkTaskStatus: 'ពិនិត្យស្ថានភាពភារកិច្ច',
        teamProgress: 'វឌ្ឍនភាពក្រុម · ថ្ងៃនេះ',
        realtimePortCompletion: 'ស្ថានភាពបញ្ចប់ PORT ពេលវេលាពិត',
        completedText: 'បានបញ្ចប់',
        pendingText: 'កំពុងរង់ចាំ',
        realtimeApiValidationFlow: 'ពេលវេលាពិត · API · លំហូរផ្ទៀងផ្ទាត់',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'បណ្តាញ',
        treeBrowser: 'កម្មវិធីរុករកតាមមែកធាង',
        searchAddress: 'ស្វែងរក 0x...អាសយដ្ឋាន ឬ BD-ID',
        totalTradingVolume: 'ទំហំជួញដូរសរុប',
        members: 'សមាជិក',
        networkStructure: 'រចនាសម្ព័ន្ធបណ្តាញ',
        allLevels: 'កម្រិតទាំងអស់',
        addRemark: 'បន្ថែមកំណត់សម្គាល់',
        enterRemark: 'បញ្ចូលកំណត់សម្គាល់',
        cancel: 'បោះបង់',
        confirm: 'បញ្ជាក់',
        alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
    },
    withdraw: {
        withdraw: 'ដក',
        usdtAsset: 'ទ្រព្យសម្បត្តិ USDT',
        withdrawAmount: 'ចំនួនដក',
        availableBalance: 'សមតុល្យអាចប្រើបាន',
        fee: 'កម្រៃ',
        actualArrival: 'ចំនួនបានទទួលពិតប្រាកដ',
        submit: 'ដាក់ស្នើ',
        withdrawSuccess: 'ដកបានជោគជ័យ',
        withdrawFailed: 'ដកបរាជ័យ',
        processing: 'កំពុងដំណើរការ',
        completed: 'បានបញ្ចប់',
        withdrawHistory: 'ប្រវត្តិការដក'
    },
    popup: {
        taskUnfinished: 'ភារកិច្ចមិនទាន់បញ្ចប់',
        taskUnfinishedDesc: 'ទិន្នន័យជួញដូរមិនទាន់ឈានដល់ស្តង់ដារផ្ទៀងផ្ទាត់ PoRT ថ្ងៃនេះ',
        todayTradingVolume: 'ទំហំជួញដូរថ្ងៃនេះ',
        remaining: 'នៅសល់',
        toComplete: 'ដើម្បីបញ្ចប់ភារកិច្ចថ្ងៃនេះ',
        tradingVolumeThreshold: '',
        deadline: 'ពេលវេលាដល់កាលកំណត់ភារកិច្ច',
        tryAgain: 'ព្យាយាមម្ដងទៀតក្រោយ',
        goTrade: 'ទៅជួញដូរ',
        taskCompleted: 'ភារកិច្ចបានផ្ទៀងផ្ទាត់',
        taskCompletedDesc: 'ភស្តុតាងជួញដូរ PoRT ថ្ងៃនេះបានកត់ត្រាលើ blockchain ជោគជ័យ',
        rewardIssued: 'បានចែកចាយរង្វាន់',
        complete: 'បានបញ្ចប់',
        shareTitle: 'ចែករំលែកការអញ្ជើញ',
        shareDesc: 'អញ្ជើញមិត្តភក្តិចុះឈ្មោះ ទាំងពីរទទួលបានរង្វាន់',
        referralLink: 'តំណអញ្ជើញ',
        qrCode: 'QR កូដ',
        copyLink: 'ចម្លងតំណ',
        notask:'ថ្ងៃនេះគ្មានភារកិច្ចទេ',
        notaskDesc:'បច្ចុប្បន្នមិនមានភារកិច្ចជួញដូរ PoRT ដែលកំពុងរង់ចាំដំណើរការទេ',
    }
};
